import React, { useState } from 'react'
import { Table, Button, Container, Col, Row, Badge, FormControl, InputGroup } from 'react-bootstrap'
import './UserList.css'
import SaveUserDialog from './SaveUserDialog';
import { BsPencilSquare, BsPlus, BsSearch, BsStarFill } from "react-icons/bs";

const UserList = ({
    users,
    createDialogOpen,
    updateDialogOpen,
    userForm,
    username,
    role,
    organizationId,
    password,
    saveUserError,
    loggedInUser,
    loggedInUserRole,
    loggedInUserOrganizationId,
    addUserClicked,
    updateUserClicked,
    closeDialogClicked,
    deleteUser,
    createUser,
    updateUser,
    resetUserPassword,
    resetPasswordSuccess,
    careUnits,
    opticians,
    onUserValueChange,
    isLoading,
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const openCreateUser = () => {
        addUserClicked();
    };

    const filteredUsers = (users || []).filter(u => {
        if (!searchTerm) return true;
        return u.username?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
        <div className="UserList">
            <Container id={"usersMainGrid"} className="">
                <Row>
                    <Col xs={12}>
                        <h1>Användare</h1>
                    </Col>
                </Row>
                <Row className="mt-5 mb-4">
                    <Col xs={12} sm={6} md={4}>
                        <InputGroup>
                            <InputGroup.Text className="SaveUserDialog-input-icon"><BsSearch /></InputGroup.Text>
                            <FormControl
                                type="text"
                                placeholder="Sök på användarnamn..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={12} sm={6} md={8} className="d-flex align-items-end justify-content-end">
                        <Button className="add-button mb-0" onClick={() => openCreateUser()}>
                            <BsPlus /> Lägg till
                        </Button>
                    </Col>
                </Row>
            </Container>
            {(updateDialogOpen && (
                    <div>
                        <SaveUserDialog
                            saveErrorMessage={saveUserError}
                            onCancelClicked={closeDialogClicked}
                            onUpdateClicked={updateUser}
                            onDeleteClicked={deleteUser}
                            onResetPasswordClicked={resetUserPassword}
                            resetPasswordSuccess={resetPasswordSuccess}
                            username={username}
                            role={role}
                            organizationId={organizationId}
                            careUnits={careUnits}
                            opticians={opticians}
                            userForm={userForm}
                            loggedInUser={loggedInUser}
                            loggedInUserRole={loggedInUserRole}
                            loggedInUserOrganizationId={loggedInUserOrganizationId}
                            isLoading={isLoading}
                        />
                    </div>
                )) ||
                (createDialogOpen && (
                    <SaveUserDialog
                        saveErrorMessage={saveUserError}
                        userForm={{}}
                        onCancelClicked={closeDialogClicked}
                        onSaveClicked={createUser}
                        careUnits={careUnits}
                        opticians={opticians}
                        loggedInUser={loggedInUser}
                        loggedInUserRole={loggedInUserRole}
                        loggedInUserOrganizationId={loggedInUserOrganizationId}
                        isLoading={isLoading}
                    />
                ))}
            <Table size="sm" hover responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Användarnamn</th>
                        <th>Roll</th>
                        <th>Organisation</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {filteredUsers.map((u, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{u.username}</td>
                                <td>
                                    {u.role}
                                    {(u.role === 'CARE_UNIT_ADMIN' || u.role === 'OPTICIAN_ADMIN') && (
                                        <Badge bg="warning" className="password-reset-badge">
                                            <BsStarFill />
                                        </Badge>
                                    )}
                                </td>
                                <td>{u.organizationName}</td>
                                <td>
                                    {(u.username === loggedInUser && <i>Nuvarande användare</i>) || (
                                        <div className={"float-end table-buttons d-flex align-items-center"}>
                                            <Button
                                                onClick={() =>
                                                    updateUserClicked(u)
                                                }
                                                disabled={u.username === loggedInUser}
                                            >
                                                <BsPencilSquare /><span> Uppdatera</span>
                                            </Button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </div>
    );
};
export default UserList;